export default "__VITE_ASSET__BgubZUVP__"